import { IResponsiveInt } from '@faire/web-api--source/indigofair/data/IResponsiveInt';
import { ISDUIText } from '@faire/web-api--source/indigofair/data/ISDUIText';
import { ISearchSuggestionPill } from '@faire/web-api--source/indigofair/data/ISearchSuggestionPill';

export namespace ISearchSuggestionsComponent {
  /**
   * Component variant to distinguish between different layouts
   * Client side renders the component differently based on this variant
   */
  export enum SearchSuggestionVariant {
    SEARCH_SUGGESTION_VARIANT_UNKNOWN = 'SEARCH_SUGGESTION_VARIANT_UNKNOWN',
    COLUMN = 'COLUMN',
    FLOW_ROW = 'FLOW_ROW',
  }

  /**
   * Return an instance of ISearchSuggestionsComponent with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ISearchSuggestionsComponent>
  ): ISearchSuggestionsComponent =>
    ({
      pills: [],
      ...(partial ?? {}),
    }) as ISearchSuggestionsComponent;
}

export interface ISearchSuggestionsComponent {
  /**
   * Title for the Component. Example: "Recently viewed brands"
   */
  title: ISDUIText | undefined;
  pills: Array<ISearchSuggestionPill>;
  /**
   * responsive configuration for max number pills to display.
   */
  responsive_pills_config: IResponsiveInt | undefined;
  variant:
    | keyof typeof ISearchSuggestionsComponent.SearchSuggestionVariant
    | undefined;
}
